<!DOCTYPE html>
<div id="activities-download-panel" class="ot-panel">
  <div class="otsc-prop-header">
    <h1 class="otsc-header-text" i18n>All Environments</h1>
  </div>
  <div class="ot-panel__header">
    <app-tabs [identifier]="'activities-download-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="downloadTabs" [color]="TabColor.PRIMARY" [selectedIndex]="activeTab"></app-tabs>
  </div>
  @if (activeTab == ActivityDownloadTab.PRODUCTS) {
    <div class="table-container">
      <app-datatable [identifier]="'activities-download-products-table'" [cols]="productCols" [rows]="products" (onclickcolumn)="sortProducts($event)"
        [showcheckboxes]="true" [pagination]="true" [isloading]="loading" [total]="productTotal"
        [currentPage]="currentProductsPage" (pageevent)="onPageChange($event, DownloadType.PRODUCT)" (actionmenuevent)="actionMenuClicked($event)"
      (onchangefilter)="onProductFilterChanged($event)" (rowclickevent)="rowClick($event)"></app-datatable>
    </div>
  }
  @if (activeTab == ActivityDownloadTab.UPDATES) {
    <div class="table-container">
      <app-datatable [identifier]="'activities-download-updates-table'" [cols]="updateCols" [rows]="updates" (onclickcolumn)="sortUpdates($event)"
        [showcheckboxes]="true" [pagination]="true" [isloading]="loading" [total]="updateTotal"
        [currentPage]="currentUpdatesPage" (pageevent)="onPageChange($event, DownloadType.UPDATE)" (actionmenuevent)="actionMenuClicked($event)"
      (onchangefilter)="onUpdateFilterChanged($event)" (rowclickevent)="rowClick($event)"></app-datatable>
      <!DOCTYPE html>
    </div>
  }
  @if (activeTab == ActivityDownloadTab.HOTFIXES) {
    <div class="table-container">
      <app-datatable [identifier]="'activities-download-hotfixes-table'" [cols]="hotfixCols" [rows]="hotfixes" (onclickcolumn)="sortHotfixes($event)"
        [showcheckboxes]="true" [pagination]="true" [isloading]="loading" [total]="hotfixTotal"
        [currentPage]="currentHotfixesPage" (pageevent)="onPageChange($event, DownloadType.HOTFIX)" (actionmenuevent)="actionMenuClicked($event)"
      (onchangefilter)="onHotfixFilterChanged($event)" (rowclickevent)="rowClick($event)"></app-datatable>
      <!DOCTYPE html>
    </div>
  }
  @if (activeTab == ActivityDownloadTab.LANGUAGE_PACKS) {
    <div class="table-container">
      <app-datatable [identifier]="'activities-download-language-pack-table'" [cols]="langCols" [rows]="langs" (onclickcolumn)="sortLanguages($event)"
        [showcheckboxes]="true" [pagination]="true" [isloading]="loading" [total]="langTotal"
        [currentPage]="currentLanguagesPage" (pageevent)="onPageChange($event, DownloadType.LANG)" (actionmenuevent)="actionMenuClicked($event)"
      (onchangefilter)="onLangFilterChanged($event)" (rowclickevent)="rowClick($event)"></app-datatable>
      <!DOCTYPE html>
    </div>
  }
</div>
